module.exports = __webpack_public_path__ + "static/media/icon-track-assignment-open-hw.c91ba277.svg";